<template lang="pug">
  .box
    .box-header.b-b
      h3 Outlets
      small Filter by outlets
      
    .box-body
      div(v-if="!loading")

        p(v-if="outletList.length === 0") No outlets available.

        p(v-if="outletList.length <= 5" v-for="o in outletList")
          label.md-check
            input(
              type="checkbox"
              v-model="selectedOutlets"
              :value="o.id"
            )
            i.indigo
            | {{ o.name }}

        multiselect(
          deselect-label=""
          label="name"
          placeholder="All outlets"
          select-label=""
          track-by="id"
          v-if="outletList.length > 5"
          v-model="selectedOutletsMultiselect"
          :clear-on-select="false"
          :close-on-select="false"
          :hide-selected="true"
          :loading="outletList.length === 0"
          :multiple="true"
          :options="outletList"
        )
        
      .loading(v-if="loading")
        .loading-spinner
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        value: {
            type: Array,
            required: false,

            default() {
                return [];
            },
        },
    },

    computed: {
        ...mapGetters('outlet', ['outletList']),

        loading() {
            return this.onLoading('fetch-outlet');
        },

        selectedOutlets: {
            get() {
                return this.value;
            },

            set(value) {
                this.$emit('input', value);
            },
        },

        selectedOutletsMultiselect: {
            get() {
                return this.value.map(r =>
                    this.outletList.find(x => x.id === r),
                );
            },

            set(value) {
                this.$emit('input', value.map(r => r.id));
            },
        },
    },

    mounted() {
        this.getOutletListIfNecessary();
    },

    methods: {
        ...mapActions('outlet', ['getOutletListIfNecessary']),
    },
};
</script>

<style lang="scss" scoped>
.box-body {
    p:last-child {
        margin-bottom: 0;
    }
}

.loading {
    line-height: 1;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/common/outlet-filter.vue